/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="85.72"
        viewBox="0 0 82.25 85.72"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M81 0a1.24 1.24 0 0 1 1.24 1.12v75.94a7.37 7.37 0 0 1-.27 2.08 8.79 8.79 0 0 1-8 6.58H9.12a1.25 1.25 0 0 1-.13-2.49h64.74a6.29 6.29 0 0 0 5.85-4.76 4.62 4.62 0 0 0 .16-1.1V2.5H18.06v74.1a1.24 1.24 0 0 1-1.12 1.24h-.14a1.25 1.25 0 0 1-1.24-1.12V1.25A1.24 1.24 0 0 1 16.68.01H81Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.78 11.09H28.4a1.75 1.75 0 0 0-1.75 1.75v17.1a1.75 1.75 0 0 0 1.75 1.75h16.38a1.75 1.75 0 0 0 1.72-1.75v-17.1a1.76 1.76 0 0 0-1.72-1.75Zm-.75 2.5v15.6H29.15v-15.6Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M69.9 13.79a1.252 1.252 0 0 1 .13 2.5H55.7a1.25 1.25 0 0 1-.13-2.49H69.9ZM69.9 27.04a1.25 1.25 0 0 1 .13 2.49H55.7a1.252 1.252 0 0 1-.13-2.5H69.9ZM69.9 40.28a1.252 1.252 0 0 1 .13 2.5H27.9a1.25 1.25 0 0 1-.13-2.49H69.9ZM69.9 53.5a1.252 1.252 0 0 1 .13 2.5H27.9a1.252 1.252 0 0 1-.13-2.5H69.9ZM69.9 66.77a1.25 1.25 0 0 1 .13 2.49H27.9a1.252 1.252 0 0 1-.13-2.5H69.9ZM16.8 53.12a1.25 1.25 0 0 1 .13 2.49H2.5v21a6.34 6.34 0 0 0 6.3 6.62h.24c3.72 0 6.51-2.45 6.51-6.62a1.25 1.25 0 0 1 2.5 0c0 5.63-4 9.19-9 9.12a8.82 8.82 0 0 1-9-8.83V54.37a1.24 1.24 0 0 1 1.12-1.24H16.8Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'OnePagePaperArticleIcon';

export default Icon;
